<template lang="pug">

    v-menu(
        :close-on-content-click='false'
        transition='scale-transition'
        offset-y
        max-width='290px'
        min-width='290px'
    )
        template(v-slot:activator="{ on, attrs }")
            v-row(gutter="4")
                v-col(cols="auto")
                    v-btn(@click="quickReply('visit');" color="grey" small :disabled="llmResponseIsLoading")
                        | Visit Dealer
                v-col(cols="auto").pl-5.pr-5
                    v-btn(@click="quickReply('no_stock');" color="grey" small :disabled="llmResponseIsLoading")
                        | No Stock
                v-col(cols="auto")
                    v-btn(@click="quickReply('in_stock');" color="grey" small :disabled="llmResponseIsLoading")
                        | In stock
</template>

<script lang="ts">
import Vue from 'vue';

// Components

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    },
    components: {

    },
    props: {
        llmResponseIsLoading: Boolean,
        quickReply: Function,
    },
    watch: {

    },
    created() {
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

</style>